import { hasRequiredRole } from '../utils/user'
import { useCurrentRole } from './use-derived-auth'

import type { Role } from '../types'

/**
 * Check if the current user has the required role
 * @param requiredRole - The minimum role required
 * @returns true if the user's role meets or exceeds the requirement
 */
export const useHasRole = (requiredRole: Role): boolean => {
	const currentRole = useCurrentRole()
	return currentRole ? hasRequiredRole(currentRole, requiredRole) : false
}
